
// stands for the static data for the example website on subscription process page 2

import adv1 from "../resources/example/default_advertisment_1.jpg";
import adv2 from "../resources/example/default_advertisment_2.jpg";
import adv3 from "../resources/example/default_advertisment_3.jpg";
import adv4 from "../resources/example/default_advertisment_4.jpg";

export const exampleData = {
    website_name:"Webingo",
    details:"Webingo - אתר ליצירת אתרים לעסקים קטנים עד בינוניים!",
    phone:"050-1234567",
    email:"example_email@gmail.com",
    address:"אלנבי 22, תל אביב",
    jobs:[
        {
            createdAt: "פורסם לפני שעה",
            details: "העבודה במשרה מלאה (9:00-18:00) במשרדי החברה.",
            requirements: [
                "תואר ראשון בעיצוב גרפי",
                "שליטה מלאה בתוכנות Adobe",
                "תיק עבודות מרשים",
                "יצירתיות וראש גדול"
            ],
            benefits: [
                "כרטיס כניסה חופשי לאירועי תרבות",
                "השתלמויות מקצועיות"
            ],
            desc: "דרוש/ה מעצב/ת גרפי/ת למשרד פרסום צעיר וחדשני. עבודה על קמפיינים גדולים.",
            title: "מעצב/ת גרפי/ת"
        },
        {
            createdAt: "פורסם לפני 3 שעות",
            details: "עבודה במשרה חלקית, 4 משמרות בשבוע. כולל סופי שבוע.",
            requirements: [
                "שירותיות ויחסי אנוש מצוינים",
                "סדר וארגון",
                "נכונות לעבודה מאומצת"
            ],
            benefits: [
                "הטבות בחנות",
                "בונוסים על עמידה ביעדים"
            ],
            desc: "דרוש/ה נציג/ת מכירות לחנות אופנה יוקרתית בקניון מרכזי.",
            title: "נציג/ת מכירות"
        },
        {
            createdAt: "פורסם לפני יום",
            details: "העבודה במשרה מלאה, שעות גמישות. אפשרות לעבודה היברידית.",
            requirements: [
                "ניסיון של 3 שנים ומעלה בפיתוח Full-Stack",
                "שליטה ב-React ו-Node.js",
                "יכולת עבודה בצוות",
                "אנגלית ברמה גבוהה"
            ],
            benefits: [
                "תנאים סוציאליים מעולים",
                "קרן השתלמות",
                "ארוחות מסובסדות"
            ],
            desc: "דרוש/ה מפתח/ת תוכנה מנוסה להצטרפות לצוות פיתוח בחברה גלובלית.",
            title: "מפתח/ת Full-Stack"
        },
        {
            createdAt: "פורסם לפני 4 ימים",
            details: "עבודה במשמרות (בוקר/ערב), כולל סופי שבוע. יום חופש קבוע באמצע השבוע.",
            requirements: [
                "ניסיון קודם בתחום המסעדנות - יתרון",
                "יכולת עבודה תחת לחץ",
                "חריצות ואדיבות"
            ],
            benefits: [
                "טיפים גבוהים",
                "ארוחות עובדים"
            ],
            desc: "דרוש/ה מלצר/ית למסעדה איטלקית במרכז תל אביב. אווירה משפחתית ודינמית.",
            title: "מלצר/ית"
        },
        {
            createdAt: "פורסם לפני שבועיים",
            details: "עבודה במשרה מלאה, שעות בוקר 8:00-17:00. ללא גמישות.",
            requirements: [
                "תעודת הנהלת חשבונות סוג 2",
                "ניסיון של שנה לפחות בתחום",
                "שליטה בתוכנות אופיס ופריוריטי"
            ],
            benefits: [
                "השתתפות בהוצאות נסיעה",
                "ימי גיבוש"
            ],
            desc: "לחברה פיננסית מובילה דרוש/ה מנהל/ת חשבונות לביצוע פעולות חשבונאיות שוטפות.",
            title: "מנהל/ת חשבונות"
        },
    ],
    products:[
        {
            name:"אוזניות",
            price:120,
            company:"יצרן1",
            hasDis:true,
            disValue:0.6,
            isNew: false,
        },
        {
            name:"מחשב נייד",
            price:2300,
            company:"יצרן2",
            hasDis:true,
            disValue:0.8,
            isNew: false,
        },
        {
            name:"אופניים",
            price:750,
            company:"יצרן3",
            hasDis:false,
            disValue:1,
            isNew: true,
        },
        {
            name:"רחפן",
            price:50,
            company:"יצרן4",
            hasDis:false,
            disValue:1,
            isNew: true,
        },
        {
            name:"שולחן אוכל",
            price:325,
            company:"יצרן5",
            hasDis:false,
            disValue:1,
            isNew: true,
        },
        {
            name:"אוהל מתקפל",
            price:800,
            company:"יצרן6",
            hasDis:true,
            disValue:0.75,
            isNew: false,
        },
        {
            name:"שידה+מראה",
            price:1520,
            company:"יצרן7",
            hasDis:true,
            disValue:0.8,
            isNew: false,
        },
        {
            name:"מכונית חדשה",
            price:120000,
            company:"יצרן8",
            hasDis:false,
            disValue:1,
            isNew: true,
        }
    ],
    branches:[
        {
            city:"חולון",
            address:"המגשימים 31",
            week:[
                {
                    day:"יום א'",
                    startAt:"09:00",
                    endAt:"17:30",
                    isOpen:true
                },
                {
                    day:"יום ב'",
                    startAt:"09:00",
                    endAt:"17:30",
                    isOpen:true
                },
                {
                    day:"יום ג'",
                    startAt:"09:00",
                    endAt:"17:30", 
                    isOpen:true
                },
                {
                    day:"יום ד'",
                    startAt:"09:00",
                    endAt:"17:30", 
                    isOpen:true
                },
                {
                    day:"יום ה'",
                    startAt:"09:00",
                    endAt:"17:30", 
                    isOpen:true
                },
                {
                    day:"יום ו'",
                    startAt:"09:00",
                    endAt:"14:00", 
                    isOpen:true
                },
                {
                    day:"יום שבת",
                    startAt:"",
                    endAt:"", 
                    isOpen:false
                }
            ],
            isOpen:false,
        },
        {
        city:"בת ים",
        address:"התרשיש 3",
        week:[{day:"יום א'",startAt:"08:00",endAt:"17:30", isOpen:true},{day:"יום ב'",startAt:"08:00",endAt:"17:30", isOpen:true},{day:"יום ג'",startAt:"08:00",endAt:"17:30", isOpen:true},{day:"יום ד'",startAt:"08:00",endAt:"17:30", isOpen:true},{day:"יום ה'",startAt:"08:00",endAt:"17:30", isOpen:true},{day:"יום ו'",startAt:"08:00",endAt:"14:30", isOpen:true},{day:"יום שבת",startAt:"",endAt:"", isOpen:false}],
        isOpen:true,
        },
        {
            city:"תל אביב",
            address:"אלנבי 7",
            week:[
                {
                    day:"יום א'",
                    startAt:"09:00",
                    endAt:"17:30", 
                    isOpen:true
                },
                {
                    day:"יום ב'",
                    startAt:"09:00",
                    endAt:"17:30", 
                    isOpen:true
                },
                {
                    day:"יום ג'",
                    startAt:"09:00",
                    endAt:"17:30", 
                    isOpen:true
                },
                {
                    day:"יום ד'",
                    startAt:"09:00",
                    endAt:"17:30", 
                    isOpen:true
                },
                {
                    day:"יום ה'",
                    startAt:"09:00",
                    endAt:"17:30", 
                    isOpen:true
                },
                {
                    day:"יום ו'",
                    startAt:"09:00",
                    endAt:"14:00", 
                    isOpen:true},
                {
                    day:"יום שבת",
                    startAt:"",
                    endAt:"", 
                    isOpen:false
                }
            ],
            isOpen:false,
        },
        {
            city:"תל אביב",
            address:"ז'בוטינסקי 25",
            week:[
                {
                    day:"יום א'",
                    startAt:"09:00",
                    endAt:"17:30", 
                    isOpen:true
                },
                {
                    day:"יום ב'",
                    startAt:"09:00",
                    endAt:"17:30", 
                    isOpen:true
                },
                {
                    day:"יום ג'",
                    startAt:"09:00",
                    endAt:"17:30", 
                    isOpen:true
                },
                {
                    day:"יום ד'",
                    startAt:"09:00",
                    endAt:"17:30", 
                    isOpen:true
                },
                {
                    day:"יום ה'",
                    startAt:"09:00",
                    endAt:"17:30", 
                    isOpen:true
                },
                {
                    day:"יום ו'",
                    startAt:"09:00",
                    endAt:"14:00", 
                    isOpen:true
                },
                {
                    day:"יום שבת",
                    startAt:"",
                    endAt:"", 
                    isOpen:false
                }
            ],
            isOpen:true,
        }
    ],
    advs:[adv1,adv2,adv3,adv4],
}